// extracted by mini-css-extract-plugin
module.exports = {"modal":"__modal___1Fv0j","paper":"__paper___1Alto","container":"__container___bu6XU"};